module.exports = __webpack_public_path__ + "media/images/countryrect/bl-912aebf9aa6ec041c1f02248bcf9aa8a.svg";